import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-date-range-filter',
  templateUrl: './custom-date-range-filter.component.html',
  styleUrls: ['./custom-date-range-filter.component.scss'],
  standalone: true,
  imports: [TableModule, FormsModule, DatePickerModule, ReactiveFormsModule]
})
export class CustomDateRangeFilterComponent {
  @Input() field!: string;
  @Input() control!: FormControl;

  @Output() onChangeDateRangeFilter = new EventEmitter<{ propertyName: string, valueFilter: any, valueAlterFilter: any }>();

  rangeDates = signal<Date[]>([]);
  startDate: String | null = null;
  endDate: String | null = null;

  constructor() {
    this.rangeDates.set([new Date(), new Date()]);
  }

  filterInput(event: any) {
    const selectedDate = event;
    if (!this.startDate) {
      this.startDate = String(selectedDate.toLocaleDateString('en-CA'));
    }
    else if (!this.endDate) {
      this.endDate = String(selectedDate.toLocaleDateString('en-CA'));

      this.onChangeDateRangeFilter.emit({
        propertyName: this.field,
        valueFilter: this.startDate,
        valueAlterFilter: this.endDate
      });
    }
    else {
      this.startDate = String(selectedDate.toLocaleDateString('en-CA'));
      this.endDate = null;
    }

  }

}